var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 7,
  height: 11,
  viewBox: "0 0 7 11",
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_657_1472)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.10595 0.942633C6.37875 1.21543 6.37875 1.66309 6.10595 1.93589L2.64355 5.39828L6.10595 8.86068C6.37875 9.13347 6.37875 9.57414 6.10595 9.84694C5.83316 10.1197 5.39249 10.1197 5.11969 9.84694L1.16067 5.88791C0.887873 5.61512 0.887873 5.17445 1.16067 4.90166L5.1127 0.942633C5.38549 0.669838 5.83316 0.669838 6.10595 0.942633Z",
  fill: ""
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_657_1472"
}, /*#__PURE__*/React.createElement("rect", {
  width: 9.31,
  height: 5.35797,
  fill: "",
  transform: "translate(6.30762 0.740479) rotate(90)"
})))));
export default SvgIconLeft;